/**
 * @fileoverview PUT handler for the "/generative_ai/brand_guideline_update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiBrandGuidelineUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PutGenerativeAiBrandGuidelineUpdateArchivedStateProps,
  GenerativeAiBrandGuidelineUpdateArchivedStateResult,
} from "./types";

export const putGenerativeAiBrandGuidelineUpdateArchivedState = reactQueryMutationAdapter(
  generativeAiBrandGuidelineUpdateArchivedStateCacheKeys,
  (
    props: PutGenerativeAiBrandGuidelineUpdateArchivedStateProps
  ): Promise<GenerativeAiBrandGuidelineUpdateArchivedStateResult> => {
    // manipulate props here as needed guideline

    return fetch("/generative_ai/brand_guideline_update_archived_state", "PUT", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
